import 'core-js/stable';
import 'regenerator-runtime/runtime';
import VideoAbstract from './video-abstract';

export default class YouTube extends VideoAbstract {
  static getPlayer(iframe) {
    return new YT.Player(iframe.id);
  }

  autoplay() {
    this.player.addEventListener('onReady', () => {
      this.player.mute();
      this.player.playVideo();
    });
  }

  modalHandler() {
    this.player.addEventListener('onReady', () => {
      $(this.modal).on('hidden.bs.modal', () => {
        this.stop();
      });

      $(this.modal).on('shown.bs.modal', () => {
        this.play();
      });
    });
  }

  stop() {
    this.player.stopVideo();
  }

  play() {
    this.player.playVideo();
  }
}
